// import style from "@styles/events_new/eventComp.module.css";
import { COMMUNITY_MEMBER_ROLES } from "@utils/constants";

export const isOngoing = (start) => {
  const cur_time = Date.now();
  const ongoing = Number(start) - cur_time < 0; // has event started

  return ongoing;
};

export const isEventStarted = (start_timestamp) => {
  if (!start_timestamp) return false;

  const res = Number(start_timestamp) <= Date.now();
  return res;
};

export const isEventEnded = (end_timestamp) => {
  if (!end_timestamp) return false;

  const res = Number(end_timestamp) < Date.now();
  return res;
};

export const isCommunityAdmin = (
  memberRole,
  eventCreatorUid,
  currentUserUid
) => {
  if (eventCreatorUid === currentUserUid) return true;

  //console.log("++++++++", memberRole);

  //console.log("memberRole===>", memberRole);

  if (
    memberRole === COMMUNITY_MEMBER_ROLES.OWNER ||
    memberRole === COMMUNITY_MEMBER_ROLES.ADMIN
  )
    return true;

  return false;
};

export const isCommunityMember = (memberRole) => {
  if (
    memberRole === COMMUNITY_MEMBER_ROLES.GENERAL ||
    memberRole === COMMUNITY_MEMBER_ROLES.MODERATOR
  )
    return true;

  return false;
};

export const getTime = (ts) => {
  const date = new Date(Number(ts));
  return `${date.toDateString()} ${date.toLocaleTimeString()}`;
};

// export const getLocation = (address) => {
//   if (!address) return null;

//   const text = encodeURIComponent(address);
//   return `https://www.google.com/maps/search/${text}`;
// };

export const viewLocation = (address) => {
  if (!address) return () => {};

  const loc = encodeURIComponent(address);
  // trackEvent("Event Location Viewed");
  window.open(`https://www.google.com/maps/search/${loc}`);
};

export const sticky_relocate = ({
  rightBx,
  rightBx_container,
  rightBxInner,
}) => {
  const footer = document.querySelector("#event_footer");

  if (
    !rightBx.current ||
    !rightBx_container.current ||
    !rightBxInner.current ||
    !footer
  )
    return () => {};

  const window_top = document.documentElement.scrollTop;
  const footer_top = footer.offsetTop;
  const div_height =
    rightBxInner.current.clientHeight - rightBx.current.scrollTop + 140;

  //@arnab please check if all the files of this folder are beinf used or not. I couldnt find any
  // if (window_top + div_height > footer_top) {
  //   rightBx_container.current.classList.add(style.full_height);
  //   // console.log("add");
  // } else {
  //   rightBx_container.current.classList.remove(style.full_height);
  //   // console.log("remove");
  // }
};

export const getParticipationPlatformAndLink = (data) => {
  let participationPlatform = null,
    participationlink = null;
  if (data.conferenceLink) {
    participationPlatform = "different app/website.";
    participationlink = data.conferenceLink;
  } else if (data.facebook) {
    participationPlatform = "Facebook.";
    participationlink = data.facebook;
  } else if (data.youtube) {
    participationPlatform = "Youtube.";
    participationlink = data.youtube;
  } else if (data.instagram) {
    participationPlatform = "Instagram.";
    participationlink = data.instagram;
  } else {
    participationPlatform = "different webiste.";
    participationlink = data.website;
  }

  return { participationPlatform, participationlink };
};

export const removeHttp = (url) => {
  return url.replace(/^https?:\/\//, "");
};
